import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Products } from "@/components/site/Products";
import { Store } from "@/components/site/Store";
import { Reviews } from "@/components/site/Reviews";
import { Visit } from "@/components/site/Visit";
import { Footer, WhatsAppFab } from "@/components/site/Footer";
import { setLenis } from "@/components/site/motion";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.085, smoothWheel: true });
    setLenis(lenis);
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); setLenis(null); };
  }, []);

  return (
    <div className="App bg-[#0A0E3F] font-body antialiased">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Products />
        <Store />
        <Reviews />
        <Visit />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}

export default App;
